'use client';

import { Container, useModal } from '..';
import styles from './CtaSection.module.css';
import { Card, CardProps } from './Card';
import { useRouter, useSearchParams } from 'next/navigation';
import { isMobileDevice } from 'utils/isMobile';
import { UhAppModal } from 'components/shared/UHAppDownloadModal';
import { useRegionLocale } from 'contexts/RegionLocaleContext';

export const CtaSection = ({
  className,
}: {
  className?: string;
  handleCta: () => void;
}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { regionSlug } = useRegionLocale();
  const ModalClient = useModal();

  const handleUHAppClick = () => {
    if (isMobileDevice()) {
      //
      window.open('https://ultrahuman.onelink.me/QqSM/q9csmfux', '_blank');
    } else {
      ModalClient.set(
        <UhAppModal
          text=" Install the Ultrahuman app to experience the Cycle & Ovulation Pro PowerPlug."
          link="https://ultrahuman.onelink.me/QqSM/q9csmfux"
          image="web_v2/qr-codes/blood-vision-onelink.png"
        />,
      );
      ModalClient.show();
    }
  };
  const cards: CardProps[] = [
    {
      title: 'Don’t have the Ring?',
      description:
        'The Ultrahuman Ring tracks your fertility and cycle health with biomarkers like temperature, HRV, and RHR. Get yours to unlock the full suite of women’s health PowerPlugs.',
      link: '/ring/buy',
      cardTheme: 'light',
      imgSrc: 'web_v2/womens-health/ctas/1.png',
      cta: 'Buy now',
      onClick: () => {
        const qs = searchParams?.toString();
        router.push(`/${regionSlug}/ring/buy${qs ? `?${qs}` : ''}`);
      },
    },
    {
      title: 'Already have the Ring?',
      description:
        'Great! Let’s set up your cycle tracking. Follow the link below to test it out and sync your ring for personalized insights.',
      link: 'https://ultrahuman.onelink.me/QqSM/bsrsfmvk',
      cardTheme: 'dark',
      imgSrc: 'web_v2/womens-health/ctas/2.1.png',
      cta: 'Get started',
      onClick: handleUHAppClick,
    },
  ];

  return (
    <div className={styles.ctaSectionContainer}>
      <section
        className={className ? `${styles.content} ${className}` : styles.content}
      >
        <Container>
          <h2 className={styles.title}>Start tracking your cycle today</h2>
          <p className={styles.description}>
            Personalized insights for every phase of your cycle. Understand,
            optimize, and make informed choices.
          </p>
          <div className={styles.cards}>
            {cards.map((card, index) => (
              <Card {...card} key={`card-${index}`} />
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
};
